import React, { useState, useEffect } from "react";

function FileUploadHandler({ handleChange, defaultImage, attribute }) {
  const [preview, setPreview] = useState(defaultImage);

  useEffect(() => {
    setPreview(defaultImage);
  }, [defaultImage]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      handleChange(file);
    }
  };

  return (
    <div className="w-responsive d-flex justify-content-start">
      {preview ? (
        <img
          src={preview}
          alt="Preview"
          className="mb-2 max-w-full h-auto rounded"
          style={{ maxHeight: "100px", minHeight: "100px", minWidth: "100px" }}
        />
      ) : (
        <div
          className="mb-2 rounded bg-gray-light d-flex justify-content-center align-items-center"
          style={{ height: "100px", width: "100px" }}
        >Image</div>
      )}
      <input
        type="file"
        className="border border-gray-600 p-2 rounded-3"
        onChange={handleFileChange}
        {...attribute}
      />
    </div>
  );
}

export default FileUploadHandler;
